module.exports = __webpack_public_path__ + "img/62.a7abf31d.jpg";